import { forwardRef } from "react";

export default function ArrowSecond({ id, value, backgroundColor }) {
    return (
        <div className="arrow-individual-container" id={id}>
            <div
                className="arrow-individual arrow-no-two"
                style={{
                    width: '415px',
                    background: 'rgba(40, 80, 117, 1)',
                    clipPath: 'polygon(-48% 100%, -48% 87%, -16% 94%, 0% 87%, 0% 100%)',
                }}>
            </div>
            <span
                className="arrow-no-text"
                style={{
                    position: 'absolute',
                    fontSize: '120px',
                    fontWeight: 'bold',
                    color: '#fff',
                    fontFamily: "GothamCond-Bold",
                    left: '505px'
                }}>{Math.round(value)}% <div class="arrow-shadow arrow-shadow-central"></div></span>
        </div>
    );
}
